import React from 'react';
import Footer from '../../components/Footer/Footer';
import Banner from '../../components/Header/Banner';
import Services from '../../components/Services/Service';


const Home = () => {
    return (
        <>
            <Banner />
            <Services />
            <Footer />
        </>
    );
};

export default Home;